(() => {
  const SECTION_CLASS = "product-markers-section";
  const FOCUSABLE =
    'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
  const desktopQuery = window.matchMedia("(min-width: 1200px)");

  const setCardFocusability = (card, isActive) => {
    card.querySelectorAll(FOCUSABLE).forEach((el) => {
      if (isActive) {
        el.removeAttribute("tabindex");
      } else {
        el.setAttribute("tabindex", "-1");
      }
    });
  };

  const initGroup = (group) => {
    const markers = Array.from(
      group.querySelectorAll(".product-markers__marker")
    );
    const cards = Array.from(group.querySelectorAll(".product-markers__card"));
    if (!markers.length || !cards.length) return null;

    const controller = new AbortController();

    const activate = (id) => {
      const activeIndex = cards.findIndex(
        (card) => card.dataset.markerId === id
      );
      if (activeIndex < 0) return;

      const isFirstReveal = !group.classList.contains("is-revealed");
      if (isFirstReveal) group.classList.remove("is-ready");

      group.style.setProperty("--active-marker-index", activeIndex);

      if (isFirstReveal) {
        void group.offsetWidth;
        group.classList.add("is-ready");
      }

      group.classList.add("is-revealed");
      markers.forEach((marker) => {
        marker.classList.toggle("is-active", marker.dataset.markerId === id);
      });

      cards.forEach((card, index) => {
        const isActive = index === activeIndex;
        card.classList.toggle("is-active", isActive);
        card.setAttribute("aria-hidden", isActive ? "false" : "true");
        setCardFocusability(card, isActive);
      });
    };

    const collapse = () => {
      group.classList.remove("is-revealed", "is-ready");
      group.style.setProperty("--active-marker-index", 0);
      markers.forEach((marker) => marker.classList.remove("is-active"));
      cards.forEach((card) => {
        card.classList.remove("is-active");
        card.setAttribute("aria-hidden", "true");
        setCardFocusability(card, false);
      });
    };

    let isDesktop = desktopQuery.matches;

    const applyDefaultState = () => {
      group.classList.remove("is-ready");

      if (isDesktop) {
        collapse();
      } else {
        activate(markers[0].dataset.markerId);
      }

      requestAnimationFrame(() => group.classList.add("is-ready"));
    };

    markers.forEach((marker) => {
      const id = marker.dataset.markerId;

      marker.addEventListener(
        "click",
        (event) => {
          if (!desktopQuery.matches) {
            event.preventDefault();
            activate(id);
          }
        },
        { signal: controller.signal }
      );

      marker.addEventListener(
        "mouseenter",
        () => {
          if (desktopQuery.matches) activate(id);
        },
        { signal: controller.signal }
      );

      marker.addEventListener("focus", () => activate(id), {
        signal: controller.signal,
      });
    });

    desktopQuery.addEventListener(
      "change",
      (event) => {
        if (event.matches === isDesktop) return;
        isDesktop = event.matches;
        applyDefaultState();
      },
      { signal: controller.signal }
    );

    applyDefaultState();

    return controller;
  };

  const destroySection = (section) => {
    if (!section || !section._markerControllers) return;
    section._markerControllers.forEach((controller) => controller.abort());
    section._markerControllers = null;
  };

  const initSection = (section) => {
    if (!section || !section.classList.contains(SECTION_CLASS)) return;
    destroySection(section);

    const groups = Array.from(
      section.querySelectorAll(".product-markers__group")
    );
    section._markerControllers = groups
      .map((group) => initGroup(group))
      .filter(Boolean);
  };

  initSection(document.currentScript.parentElement);

  if (!window.__themeProductMarkersEvents) {
    window.__themeProductMarkersEvents = true;

    document.addEventListener("shopify:section:load", (event) => {
      initSection(event.target);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      destroySection(event.target);
    });
  }
})();
